import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Batch = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.326 6.25C27.7329 6.25 26.4415 7.54143 26.4415 9.13449V20.6725C26.4415 22.2655 27.7329 23.557 29.326 23.557H40.864C42.457 23.557 43.7485 22.2655 43.7485 20.6725V9.1345C43.7485 7.54143 42.457 6.25 40.864 6.25H29.326ZM30.1913 9.99985V19.8071H39.9986V9.99985H30.1913Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.13452 6.25002C7.54145 6.25002 6.25002 7.54145 6.25002 9.13451V20.6725C6.25002 22.2656 7.54145 23.557 9.13451 23.557H20.6725C22.2656 23.557 23.557 22.2656 23.557 20.6725V9.13452C23.557 7.54145 22.2656 6.25002 20.6725 6.25002H9.13452ZM9.99986 9.99986V19.8072H19.8072V9.99986H9.99986Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 29.326C6.25 27.7329 7.54143 26.4415 9.1345 26.4415H20.6725C22.2655 26.4415 23.557 27.7329 23.557 29.326V40.864C23.557 42.457 22.2655 43.7485 20.6725 43.7485H9.13449C7.54143 43.7485 6.25 42.457 6.25 40.864V29.326ZM9.99985 39.9986V30.1913H19.8071V39.9986H9.99985Z"
        fill={color}
      />
      <path
        d="M35.0951 26.4399C36.066 26.4399 36.8531 27.227 36.8531 28.198V33.3369H41.9919C42.9629 33.3369 43.75 34.124 43.75 35.095C43.75 36.0659 42.9629 36.853 41.9919 36.853H36.8531V41.9919C36.8531 42.9629 36.066 43.75 35.0951 43.75C34.1241 43.75 33.337 42.9629 33.337 41.9919V36.853H28.198C27.227 36.853 26.4399 36.0659 26.4399 35.095C26.4399 34.124 27.227 33.3369 28.198 33.3369H33.337V28.198C33.337 27.227 34.1241 26.4399 35.0951 26.4399Z"
        fill={color}
      />
    </svg>
  )
}
